import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";
import styles from "./LosPluginList.module.css";
import { LosPluginItem } from "../LosPluginItem/LosPluginItem";
import ViewPluginDetailsModal from "DreamStream/PluginsPage/Shared/ViewPluginDetailsModal";
import PluginDetailsItem from "DreamStream/PluginsPage/Shared/PluginDetailsItem";

import { useDeletePlugins } from "DreamStream/PluginsPage/usePlugins";

/**
 *
 * Scrollable list of LOS plugins with a header.
 */

export function LosPluginList({ plugins }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  const { deletePlugin } = useDeletePlugins();

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedPlugin, setSelectedPlugin] = useState(null);

  const handleDetails = (data) => {
    setDetailsModalOpen(true);
    setSelectedPlugin(data);
  };

  const handleGroupDelete = () => {
    var deleteObject = {
      type: "los",
      deleteData: {
        pluginId: selectedPlugin.targetId,
        iboNumber: selectedPlugin.plugeeIBONumber,
        groupId: selectedPlugin.targetGroupId,
      },
    };
    deletePlugin.mutateAsync(deleteObject);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.item}>Plugee IBO</div>
          <div className={styles.item}>Plugee Org/Group</div>
          <div className={classNames(styles.item, styles.iboTargetText)}>
            Target IBO
          </div>
          <div className={classNames(styles.item, styles.orgTargetText)}>
            Target Org/Group
          </div>
          {/* <div className={classNames(styles.item, styles.groupTypeText)}>
          As Pin
        </div> */}
        </div>

        <div className={classNames(styles.dragger)} {...events} ref={ref}>
          {plugins.map((item, index) => (
            <div
              key={index}
              className={classNames(
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              )}
            >
              <LosPluginItem
                pluginInfo={item}
                onClick={() => handleDetails(item)}
              />
            </div>
          ))}
        </div>

        <ViewPluginDetailsModal
          title="VIEW LOS PLUGIN DETAILS"
          isOpen={detailsModalOpen}
          errors={[]}
          onClose={() => setDetailsModalOpen(false)}
          onDelete={handleGroupDelete}
          children={
            <>
              {selectedPlugin && (
                <div className={styles["modal-container"]}>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>Plugin ID:</div>
                    <div className={styles["detail-column"]}>
                      {selectedPlugin.id}
                    </div>
                  </div>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>
                      The Following User
                    </div>
                    <div className={styles["detail-column"]}>
                      <PluginDetailsItem
                        // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                        name={`${selectedPlugin.plugeeOrganizationName} ${selectedPlugin.plugeeBusinessType}`}
                        isGroup={true}
                        // id={selectedPlugin.plugeeIBONumber}
                        id={selectedPlugin.plugeeGroupId}
                      />
                    </div>
                  </div>
                  <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>
                      Is Plugged Into Downline
                    </div>
                    <div className={styles["detail-column"]}>
                      <PluginDetailsItem
                        // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                        name={`${selectedPlugin.targetOrganizationName} ${selectedPlugin.targetGroupName}`}
                        isGroup={true}
                        // id={selectedPlugin.targetIBONumber}
                        id={selectedPlugin.targetGroupId}
                      />
                    </div>
                  </div>
                  {/* <div
                    className={classNames(
                      styles["detail-container"],
                      styles["detail-admin"]
                    )}
                  >
                    <div className={styles["label-column"]}>As Pin</div>
                    <div className={styles["detail-column"]}>
                      <span className={styles.bold}>
                        {selectedPlugin.asPin}
                      </span>
                      and {""}
                      <span className={styles.bold}>does not replace them</span>
                    </div>
                  </div> */}
                  {/* <div className={styles["detail-container"]}>
                    <div className={styles["label-column"]}>Date Created</div>
                    <div className={styles["detail-column"]}>
                      {`${selectedPlugin.date} ${selectedPlugin.time}`}
                    </div>
                  </div> */}
                </div>
              )}
            </>
          }
        />
      </div>
    </>
  );
}

LosPluginList.propTypes = {
  /**
   * Array of plugin objects
   */
  plugins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      plugee: PropTypes.string,
      target: PropTypes.string,
      asPin: PropTypes.string,
      date: PropTypes.string,
      time: PropTypes.string,
    })
  ),
};
